import { z } from 'zod'
import { fallback } from '../../../utilities'
import { brandBackgroundColorConstant, colorSchema } from './common'

const fallbackData = {
	show: false,
	color: brandBackgroundColorConstant,
}

export const feedAdCardsSchema = z.object({
	show: z.boolean().or(fallback(fallbackData.show)),
	color: colorSchema.or(fallback(fallbackData.color)),
}).or(fallback(fallbackData))

export type FeedAdCards = z.infer<typeof feedAdCardsSchema>

export const feedAdCardsDefault: FeedAdCards = {
	show: fallbackData.show,
	color: fallbackData.color,
}
